export default "__VITE_ASSET__CjItQVAX__"